import React from "react";

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconDashboard: React.FC<IconProps> = ({
  size = 19,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M15.2116 1.04688H3.78843C2.27431 1.04688 1.04688 2.27431 1.04688 3.78843V15.2116C1.04688 16.7257 2.27431 17.9531 3.78843 17.9531H15.2116C16.7257 17.9531 17.9531 16.7257 17.9531 15.2116V3.78843C17.9531 2.27431 16.7257 1.04688 15.2116 1.04688Z"
      stroke="currentColor"
      strokeWidth="1.21847"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.71973 9.5001H6.19103L7.91821 12.2417L11.0801 6.75854L12.8073 9.5001H14.2786"
      stroke="currentColor"
      strokeWidth="1.21847"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconDashboard;
